import http from "./httpService";

const flatApiEndPoint = "/sensitivities/";
const groupedApiEndPoint = "/sensitivity-config/";

export function listAllSensitivities() {
  return http.get(flatApiEndPoint);
}

export function updateSensitivity(id, payload) {
  return http.patch(`${flatApiEndPoint}${id}/`, payload);
}

function getSensitivities() {
  return http.get(groupedApiEndPoint);
}

export default getSensitivities;

export const SENSITIVITY_TYPES = [
  { key: "body", label: "Body" },
  { key: "bag", label: "Bag" },
];
